import { render, staticRenderFns } from "./ByCustomerAndCategory.vue?vue&type=template&id=42cf9f95&scoped=true&"
import script from "./ByCustomerAndCategory.vue?vue&type=script&lang=js&"
export * from "./ByCustomerAndCategory.vue?vue&type=script&lang=js&"
import style0 from "./ByCustomerAndCategory.vue?vue&type=style&index=0&id=42cf9f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf9f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VProgressLinear,VSelect,VSwitch})
